var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"custom_3"},[_c('div',{staticClass:"custom3_title"},[_vm._v(_vm._s(_vm.newsObj.title))]),_c('div',{staticClass:"custom3_describe_text"},[_vm._v(_vm._s(_vm.newsObj.describeText))]),_c('div',{staticClass:"custom3_see",on:{"click":_vm.seePre}},[_vm._v("查看处方详情")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }